import { render, staticRenderFns } from "./ChamberHistogram.vue?vue&type=template&id=ca1ab5ca&"
import script from "./ChamberHistogram.vue?vue&type=script&lang=js&"
export * from "./ChamberHistogram.vue?vue&type=script&lang=js&"
import style0 from "./ChamberHistogram.vue?vue&type=style&index=0&id=ca1ab5ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports